var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavbarDropdown',{attrs:{"items":_vm.items,"active":_vm.active,"text":_vm.active.code != null ? _vm.label(_vm.active) : _vm.$t('general.loading')},on:{"click:item":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }